import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "content-container__main-panel main-panel" }

import processAfterLogin from '@/appLogic/initializers/processAfterLogin';
import DashboardContent from './Content.vue';
import { i18n } from '@/i18n';
import { isInitialized } from '@/initProcess';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { provideLoadingStore } from '@/injectStore/loadingStore';
import { reactive, computed, onMounted } from 'vue';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import SideBar from '@/components/SidebarPlugin/SideBar.vue';
// マイナス在庫確認をONにするかどうか
const minusCheckerValid = true; // とりあえず諸々パスするまでfalse


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardLayout',
  setup(__props) {

const sleep = (ms: number) =>
  new Promise((resolve: any) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });

provideLoadingStore();
const state = reactive<Record<string, any>>({
  isReady: false, // 初期化完了したらtrue
  showSidebar: false, // TODO: もしサイドバーをon/offしたいなら、widthの変更も必要
  sidebarBackground: 'main',
  sidebarBackgroundImage: require('@/assets/img/sidebar-2.jpg'),
  calendarChecker: false,
  minusBusinessChecker: false,
  minusErrors: { state: true, errors: [] } as { state: boolean; errors: IBusiness[] },
  calendarFails: [],
  checkCalendarOkButtonStr: String(i18n.t('稼働日を指定する')),
  checkCalendarCancelButtonStr: String(i18n.t('全日程稼働日にする')),
  // とりあえずdataで定義しておく
  store: useStore(),
  router: useRouter(),
  route: useRoute(),
}) as Record<string, any>;

const computedColumnWidths = computed(() => {
  const sideBarWidth = state.showSidebar ? '140px' : '70px';
  return `${sideBarWidth} minmax(0, 1fr)`;
});

onMounted(async () => {
  do {
    await sleep(50);
  } while (!isInitialized()); // 初期化完了まで待つ
  await processAfterLogin(); // Layoutが表示されているということは、つまりログインが完了しているということ

  state.isReady = true;
});
const onClickSideBar = () => {
  state.showSidebar = !state.showSidebar;
};

return (_ctx: any,_cache: any) => {
  const _component_notifications = _resolveComponent("notifications")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_notifications),
    _createElementVNode("div", {
      class: "content-container",
      style: _normalizeStyle({ 'grid-template-columns': computedColumnWidths.value })
    }, [
      _createVNode(SideBar, {
        id: "sidebar",
        class: "content-container__sidebar",
        onToggleHideMode: onClickSideBar
      }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(DashboardContent)
      ])
    ], 4)
  ]))
}
}

})